// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating Contact Enquiry Button */
.contact_enquiry_fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1040;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(135deg, #00c853 0%, #00a844 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  box-shadow: 0 6px 20px rgba(0, 200, 83, 0.4);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.contact_enquiry_fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(0, 200, 83, 0.5);
}

.contact_enquiry_fab i {
  font-size: 20px;
}

@media (max-width: 575px) {
  .contact_enquiry_fab span {
    display: none;
  }
  .contact_enquiry_fab {
    padding: 14px;
    border-radius: 50%;
  }
}

/* Contact enquiry inputs */
#contactEnquiryModal .emailinput .d-flex {
  width: 100%;
}

#contactEnquiryModal .emailinput input,
#contactEnquiryModal .emailinput textarea {
  width: 100%;
}

#contactEnquiryModal .emailinput textarea {
  resize: vertical;
  min-height: 110px;
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/ContactEnquiry/ContactEnquiry.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA,2BAA2B;AAC3B;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* Floating Contact Enquiry Button */\n.contact_enquiry_fab {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 1040;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 50px;\n  background: linear-gradient(135deg, #00c853 0%, #00a844 100%);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  box-shadow: 0 6px 20px rgba(0, 200, 83, 0.4);\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.contact_enquiry_fab:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 26px rgba(0, 200, 83, 0.5);\n}\n\n.contact_enquiry_fab i {\n  font-size: 20px;\n}\n\n@media (max-width: 575px) {\n  .contact_enquiry_fab span {\n    display: none;\n  }\n  .contact_enquiry_fab {\n    padding: 14px;\n    border-radius: 50%;\n  }\n}\n\n/* Contact enquiry inputs */\n#contactEnquiryModal .emailinput .d-flex {\n  width: 100%;\n}\n\n#contactEnquiryModal .emailinput input,\n#contactEnquiryModal .emailinput textarea {\n  width: 100%;\n}\n\n#contactEnquiryModal .emailinput textarea {\n  resize: vertical;\n  min-height: 110px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
